module.exports = __webpack_public_path__ + "img/video-library-icon.43066f71.svg";